import { render, staticRenderFns } from "./AccountLogout.vue?vue&type=template&id=8337969a"
import script from "./AccountLogout?vue&type=script&lang=ts&external"
export * from "./AccountLogout?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports